import { FC, useState } from 'react';
import clsx from 'clsx';
import { ICardProps } from '../List';
import { Link, useNavigate } from 'react-router-dom';
import Status from '../../../../../Status/Status';
import { useTypedSelector } from '../../../../../../lib/hooks/useTypedSelector';
import Cart from '../../../../ProductPage/Cart';
import Comment from '../../../../../Icons/Comment';

import styles from './CompactCard.module.scss';
import { commodityTypes } from '../../../../../../data/commodityTypes';
import ModalAddToCart from '../../../../../ModalAddToCart/ModalAddToCart';

import { ICardProps as IFavorites } from '../../../../FavoritesPage/components/Card/Card';
import ModalComment from '../../../../../ModalComment/ModalComment';
import { pickReplacement } from '../../../../../../helpers/replacements';

interface ICompactCard {
  data: ICardProps;
  favorites: IFavorites[];
}

const CompactCard: FC<ICompactCard> = ({ data }) => {
  const navigate = useNavigate();
  const { cart } = useTypedSelector((state) => state);
  const indexInCart = cart.findIndex((item) => item.product_id === data.id);
  const [isModalActive, setModalActive] = useState(false);
  const handleModalOpen = () => {
    setModalActive(true);
  };
  const handleModalClose = () => {
    setModalActive(false);
  };
  const [commentVisible, setCommentVisible] = useState(false);
  const [isModalCommentActive, setModalCommentActive] = useState(false);
  const handleModalCommentOpen = () => {
    setModalCommentActive(true);
  };
  const handleModalCommentClose = () => {
    setModalCommentActive(false);
  };

  const replacedByItem = pickReplacement<any>(data?.replaceBy);

  return (
    <>
      <Link
        to={'/product/' + data.slug}
        state={{ type: data.isExtra ? 'accessory' : data.type }}
        className={styles.CompactCard}
      >
        <div>
          <img
            src={
              data.isExtra
                ? commodityTypes['accessory'].icon
                : commodityTypes[data.type as keyof typeof commodityTypes].icon
            }
            alt={data.type}
          />
        </div>
        <div>
          <span>{data.article_number}</span>
        </div>
        <div>
          <span>{data.commercial_number}</span>
        </div>
        <div>
          <span>{data.name}</span>
        </div>
        <div>
          <span>{data.brand?.name}</span>
        </div>
        <div>
          <span>{data.category?.name}</span>
        </div>
        <div>{data.status && <Status status={data.status} list={true} />}</div>
        <div className={styles.btns_holder}>
          {(!data.status ||
            (typeof data.status === 'string' &&
              data.status === 'discontinued')) &&
          !replacedByItem ? null : data.in_stoke || replacedByItem ? (
            indexInCart === -1 ? (
              <button
                className={styles.cart_btn}
                onClick={(e) => {
                  e.preventDefault();
                  handleModalOpen();
                }}
              >
                <Cart />
              </button>
            ) : (
              <div className={styles.cart_holder}>
                <button
                  className={clsx(styles.cart_btn)}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/cart');
                  }}
                >
                  {cart[indexInCart].count} <Cart />
                </button>
                {cart[indexInCart].comment && (
                  <div
                    className={clsx(styles.comment, {
                      [styles.open]: commentVisible,
                    })}
                    onPointerEnter={() => setCommentVisible(true)}
                    onPointerLeave={() => setCommentVisible(false)}
                    onClick={(e) => {
                      (e.preventDefault(), handleModalCommentOpen());
                    }}
                  >
                    <Comment />
                    <p>{cart[indexInCart].comment}</p>
                  </div>
                )}
              </div>
            )
          ) : (
            <div></div>
          )}
        </div>
      </Link>
      {isModalCommentActive && (
        <ModalComment
          onClose={handleModalCommentClose}
          comment={cart[indexInCart].comment || ''}
        />
      )}
      {isModalActive && (
        <ModalAddToCart
          onClose={handleModalClose}
          data={{
            available:
              !data.count && replacedByItem
                ? replacedByItem.metaData.count
                : data.count,
            product_id:
              !data.count && replacedByItem ? replacedByItem.id : data.id,
            name:
              !data.count && replacedByItem
                ? replacedByItem.displayData.name
                : data.name,
            status:
              !data.count && replacedByItem
                ? replacedByItem.displayData.status || ''
                : data.status || '',
            cmmf:
              !data.count && replacedByItem
                ? replacedByItem.displayData.cmmf
                : data.cmmf,
            article_number:
              !data.count && replacedByItem
                ? replacedByItem.displayData.partCode
                : data.article_number,
            type:
              !data.count && replacedByItem
                ? replacedByItem.displayData.type
                : data.type,
            image:
              !data.count && replacedByItem
                ? replacedByItem.displayData.image?.s3Key || ''
                : data.image?.s3Key || '',
            count: 1,
          }}
        />
      )}
    </>
  );
};

export default CompactCard;
